import { TextFallback } from "../../../shared/components/fallbacks/skeleton/TextFallback"

export const CoursePathFallback = () => {
    return (
        <div id="data-panel__nav">
            <TextFallback variant="normal"/>
        </div>
    )
}